import { computed, makeAutoObservable, observable } from 'mobx'
import React from 'react'

const SCENES = ['SCENE_A', 'SCENE_B', 'SCENE_C', 'SCENE_D'] as const
export class ToolbarResponsiveStore {
  width = 0
  left = 0
  top = 0
  constructor() {
    makeAutoObservable(this, {
      width: observable,
      currentScene: computed,

      isSceneA: computed,
      isSceneB: computed,
      isSceneC: computed,
      isSceneD: computed,
    })
  }
  setToolbarRect({ width }: Pick<DOMRect, 'width'>) {
    this.width = width
  }
  get currentScene(): (typeof SCENES)[number] {
    if (this.width < 680) return 'SCENE_A'
    if (this.width < 830) return 'SCENE_B'
    if (this.width < 950) return 'SCENE_C'
    return 'SCENE_D'
  }
  get isSceneA() {
    return this.currentScene === 'SCENE_A'
  }
  get isSceneB() {
    return this.currentScene === 'SCENE_B'
  }
  get isSceneC() {
    return this.currentScene === 'SCENE_C'
  }
  get isSceneD() {
    return this.currentScene === 'SCENE_D'
  }
}

export const ToolbarResponsiveContext = React.createContext<ToolbarResponsiveStore | null>(null)
